import { useQueryClient } from "@tanstack/react-query";
import { useMesfRealtime } from "@dexteel/mesf-core";

const SP_TO_QUERY_KEYS: Record<string, readonly string[][]> = {
  "SCRAP.GetCommodityTypes": [["commodity-types"]],
  "SCRAP.GetCommodities": [["commodities"]],
};

export const useRealtimeInvalidation = () => {
  const queryClient = useQueryClient();

  useMesfRealtime({
    onReceiveMessage: (_author: string, message: string) => {
      const queryKeys = SP_TO_QUERY_KEYS[message];
      if (queryKeys) {
        queryKeys.forEach((queryKey) => {
          queryClient.invalidateQueries({ queryKey });
        });
      }
    },
  });
};
